<form
  [formGroup]="frm"
  (ngSubmit)="save()">
  <div class="formgrid grid anagrafica">
    <div class="field col-12">
      <h3>Anagrafica</h3>
    </div>

    <div class="field col-12 md:col-4">
      <label>Nome*</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="name" />
      <app-form-errors
        *ngIf="frm.get('name')?.errors && frm.get('name')?.dirty"
        [errors]="frm.get('name')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-4">
      <label>Sito web</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="website" />
      <app-form-errors
        *ngIf="frm.get('website')?.errors && frm.get('website')?.dirty"
        [errors]="frm.get('website')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-4">
      <label>Codice interno*</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="internal_code" />
      <app-form-errors
        *ngIf="frm.get('internal_code')?.errors && frm.get('internal_code')?.dirty"
        [errors]="frm.get('internal_code')?.errors"></app-form-errors>
    </div>
  </div>

  <div class="formgrid grid contatto">
    <div class="field col-12">
      <h3>Informazioni di contatto</h3>
    </div>

    <div class="field col-12">
      <label>Referente</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="main_contact" />
      <app-form-errors
        *ngIf="frm.get('main_contact')?.errors && frm.get('main_contact')?.dirty"
        [errors]="frm.get('main_contact')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Email principale</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="email" />
      <app-form-errors
        *ngIf="frm.get('email')?.errors && frm.get('email')?.dirty"
        [errors]="frm.get('email')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Numero di telefono</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="phone_number" />
      <app-form-errors
        *ngIf="frm.get('phone_number')?.errors && frm.get('phone_number')?.dirty"
        [errors]="frm.get('phone_number')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Fax</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="fax_number" />
      <app-form-errors
        *ngIf="frm.get('fax_number')?.errors && frm.get('fax_number')?.dirty"
        [errors]="frm.get('fax_number')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Email PEC</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="email_pec" />
      <app-form-errors
        *ngIf="frm.get('email_pec')?.errors && frm.get('email_pec')?.dirty"
        [errors]="frm.get('email_pec')?.errors"></app-form-errors>
    </div>
  </div>

  <div class="formgrid grid fiscali">
    <div class="field col-12">
      <h3>Informazioni fiscali</h3>
    </div>

    <div class="field col-12 md:col-6">
      <label>Partita Iva</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="vat_number" />
      <app-form-errors
        *ngIf="frm.get('vat_number')?.errors && frm.get('vat_number')?.dirty"
        [errors]="frm.get('vat_number')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Codice fiscale</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="fiscal_code" />
      <app-form-errors
        *ngIf="frm.get('fiscal_code')?.errors && frm.get('fiscal_code')?.dirty"
        [errors]="frm.get('fiscal_code')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Codice SDI</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="sdi" />
      <app-form-errors
        *ngIf="frm.get('sdi')?.errors && frm.get('sdi')?.dirty"
        [errors]="frm.get('sdi')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>Valuta di riferimento</label>
      <p-dropdown
        placeholder="Scegli..."
        formControlName="default_currency"
        [options]="default_currency"
        styleClass="w-full"></p-dropdown>
      <app-form-errors
        *ngIf="frm.get('default_currency')?.errors && frm.get('default_currency')?.dirty"
        [errors]="frm.get('default_currency')?.errors"></app-form-errors>
    </div>
  </div>

  <div class="formgrid grid indirizzi">
    <div class="field col-12">
      <h3>Sede legale</h3>
    </div>
    <!--
    <div class="field col-12 md:col-6">
      <label>Ufficio</label>
      <input pInputText type="text" class="w-full" formControlName="office" />
    </div>

    <div class="field col-12 md:col-6">
      <label>Codice ufficio</label>
      <input pInputText type="text" class="w-full" formControlName="office_code" />
    </div> -->

    <div class="field col-12 md:col-6">
      <label>Indirizzo*</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="address" />
      <app-form-errors
        *ngIf="frm.get('address')?.errors && frm.get('address')?.dirty"
        [errors]="frm.get('address')?.errors"></app-form-errors>
    </div>

    <div class="field col-12 md:col-6">
      <label>CAP*</label>
      <p-inputMask
        mask="99999"
        styleClass="w-full"
        formControlName="zip_code"></p-inputMask>
      <app-form-errors
        *ngIf="frm.get('zip_code')?.errors && frm.get('zip_code')?.dirty"
        [errors]="frm.get('zip_code')?.errors"></app-form-errors>
    </div>

    <div class="field col-12" *ngIf="capCitiesOptions.length > 1">
      <label>Il CAP corrisponde a più comuni — seleziona quello corretto</label>
      <p-dropdown
        [options]="capCitiesOptions"
        optionLabel="city_name"
        placeholder="Seleziona il comune..."
        styleClass="w-full"
        [showClear]="true"
        appendTo="body"
        (onChange)="applyCapResult($event.value)"></p-dropdown>
    </div>

    <div class="field col-12 md:col-4">
      <label>Regione*</label>
      <p-dropdown
        formControlName="italy_region_id"
        [options]="regions"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [emptyMessage]="'Nessun risultato trovato'"
        appendTo="body"
        placeholder="Cerca..."></p-dropdown>
    </div>

    <div class="field col-12 md:col-4">
      <label>Provincia*</label>
      <p-dropdown
        formControlName="italy_province_id"
        [options]="provinces"
        optionValue="id"
        optionLabel="name"
        styleClass="w-full"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [emptyMessage]="'Nessun risultato trovato'"
        appendTo="body"
        placeholder="Cerca..."></p-dropdown>
    </div>

    <div class="field col-12 md:col-4">
      <label>Comune*</label>
      <p-dropdown
        formControlName="italy_city_id"
        [options]="cities"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [emptyMessage]="'Nessun risultato trovato'"
        appendTo="body"
        placeholder="Cerca..."></p-dropdown>
    </div>

    <!-- <div class="field col-12 md:col-6">
      <label>Paese*</label>
      <p-dropdown
        placeholder="Scegli..."
        formControlName="country_iso"
        [options]="country"
        optionLabel="name"
        optionValue="ISO"
        styleClass="w-full"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [emptyMessage]="'Nessun risultato trovato'"
        appendTo="body"
      ></p-dropdown>
      <app-form-errors
        *ngIf="frm.get('country_iso')?.errors && frm.get('country_iso')?.dirty"
        [errors]="frm.get('country_iso')?.errors"
      ></app-form-errors>
    </div> -->
  </div>
</form>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      [label]="'Salva'"
      type="submit"
      styleClass="butt"
      [rounded]="true"
      [disabled]="frm.invalid"
      (click)="save()"></p-button>
  </div>
</div>
<!-- <pre>{{ frm.value | json }}</pre> -->
